import * as actionTypes from './actionTypes'
import * as API from '../api/Profile'

export const getProfileAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.GET_PROFILE_REQUEST, payload:data})
        return API.getProfile(data)
            .then(response => {
                dispatch({type: actionTypes.GET_PROFILE_SUCCESS, payload:response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.GET_PROFILE_ERROR, payload:error})    
            })
    }
}

export const updateProfileAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.UPDATE_PROFILE_REQUEST, payload:data})
        return API.updateProfile(data)
            .then(response => {
                dispatch({type: actionTypes.UPDATE_PROFILE_SUCCESS, payload:response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.UPDATE_PROFILE_ERROR, payload:error})    
            })
    }
}


export const checkUserUrlLink = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.CHECKUSER_URL_REQUEST, payload:data})
        return API.getUserUrl(data)
            .then(response => {
                dispatch({type: actionTypes.CHECKUSER_URL_SUCCESS, payload:response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.CHECKUSER_URL_ERROR, payload:error})    
            })
    }
}

export const updateUserUrlLink = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.UPDATEUSER_URL_REQUEST, payload:data})
        return API.updateUserUrl(data)
            .then(response => {
                dispatch({type: actionTypes.UPDATEUSER_URL_SUCCESS, payload:response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.UPDATEUSER_URL_ERROR, payload:error})    
            })
    }
}

export const deactivateAccountAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.DEACTIVATE_ACCOUNT_REQUEST, payload:data})
        return API.deActivateAccountApi(data)
            .then(response => {
                dispatch({type: actionTypes.DEACTIVATE_ACCOUNT_SUCCESS, payload:response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.DEACTIVATE_ACCOUNT_ERROR, payload:error})    
            })
    }
}






// WEBPACK FOOTER //
// ./src/actions/Profile.js